import { MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { FOCUS_RING } from "globalStyles";

export const MAIN_ID = "main";

// First focusable element of the page, only visible on keyboard focus (RGAA 12.7).
const SkipLink = () => {
    const { t } = useTranslation();

    // The main landmark is focused explicitly so the next Tab reaches its first element.
    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        document.getElementById(MAIN_ID)?.focus();
    };

    return (
        <StyledSkipLink href={`#${MAIN_ID}`} onClick={handleClick}>
            {t("skipToContent")}
        </StyledSkipLink>
    );
};

const StyledSkipLink = styled.a`
    position: absolute;
    top: 0.5rem;
    inset-inline-start: 0.5rem;
    z-index: 1000;
    padding: 0.5rem 1rem;
    background-color: #1a1a1a;
    color: #ffffff;
    font-weight: bold;
    text-decoration: none;
    border-radius: 4px;
    /* Visually hidden until focused */
    &:not(:focus) {
        clip-path: inset(50%);
        width: 1px;
        height: 1px;
        padding: 0;
        overflow: hidden;
        white-space: nowrap;
    }
    &:focus-visible {
        ${FOCUS_RING}
    }
`;

// Target of the skip link. It is focused by script only, so it needs no focus outline.
export const Main = styled.main.attrs({ id: MAIN_ID, tabIndex: -1 })`
    &:focus {
        outline: none;
    }
`;

export default SkipLink;
